import React from 'react';
import { useLocation } from 'react-router-dom';
import { ROUTES } from 'config';
import Header from 'components/layout/Header';
import Footer from 'components/layout/Footer';
import CookieBanner from 'components/common/CookieBanner';
import { LoginModalProvider } from 'contexts/LoginModalContext';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  
  // Pages where we want to hide header and footer
  const pagesWithoutHeaderFooter: string[] = [
    ROUTES.LOGIN,
    ROUTES.REGISTER,
    ROUTES.FORGOT_PASSWORD,
    '/checkout/success', // Order success page - cleaner, focused experience
  ];
  // Check if pathname matches any of the pages without header/footer, or starts with reset-password
  const shouldHideHeaderFooter = 
    pagesWithoutHeaderFooter.includes(location.pathname) || 
    location.pathname.startsWith('/reset-password');

  return (
    <LoginModalProvider>
      <div className="min-h-screen flex flex-col">
        {!shouldHideHeaderFooter && <Header />}
        <main className="flex-1">
          {children}
        </main>
        {!shouldHideHeaderFooter && <Footer />}
        {/* Site-wide cookie consent banner */}
        <CookieBanner />
      </div>
    </LoginModalProvider>
  );
};

export default Layout; 